import { useEffect, useState } from 'react';
// components
import { nomeProjeto } from 'src/config';
import useAuth from 'src/hooks/useAuth';

import ModalTags, { convertHexToColorName, getColorClass } from './ModalTags';

///
import v2_actionListaTagsChats from 'src/actions/v2/chats/v2_actionListaTagsChats';
import v2_actionCriarTag from 'src/actions/v2/chats/v2_actionCriarTag';
import v2_actionEditarTag from 'src/actions/v2/chats/v2_actionEditarTag';
import ModalConfimacao from 'src/components/modal/ModalConfimacao';
import v2_actionDeletarTag from 'src/actions/v2/chats/v2_actionDeletarTag';
import { fDate } from "src/utils/formatTime";

// Design System
import { Tag, Plus, Trash2, Pencil, Hash } from 'lucide-react';
import GenericTable from '../../../../components/table/GenericTable';
import { GENERIC_TABLE_DESIGN } from '../../../../components/table/GenericTable.design';
import { TAGS_COMPONENT_DESIGN } from './TagsComponent.design';
import { Tooltip } from '@mui/material';

// ----------------------------------------------------------------------
const TABLE_HEAD = [
  { id: 'nome', label: 'Detalhes da Etiqueta', className: 'flex-1' },
  { id: 'cor', label: 'Cor', className: 'w-48 text-center' },
  { id: 'actions', label: 'Ações', className: 'w-24 text-right' },
];
// ----------------------------------------------------------------------

export default function TagsComponent() {
  const { user } = useAuth();
  const [openDialogNovoSetor, setOpenDialogNovoSetor] = useState(false);
  const [openModalConfirmacao, setOpenModalConfirmacao] = useState(false);
  const [pesquisa, setPesquisa] = useState('');
  const [loading, setLoading] = useState(false);
  const [action, setAction] = useState('');
  ///// value fields
  const [tagId, setTagId] = useState('');
  const [listaTags, setListaTags] = useState([]);

  const [nome, setNome] = useState('');
  const [corHex, setCorHex] = useState('gray'); // Nome da cor (ex: "red", "slate", "rose")

  async function buscarListaTags() {
    try {
      let querys = `?cliente_id=${user.clienteId}`
      const response = await v2_actionListaTagsChats(querys);
      setListaTags(response.data.data)
    } catch (error) {

    }
  }

  useEffect(() => {
    buscarListaTags()
  }, []);

  function applyFilter(tableData, filterName) {
    if (filterName) {
      tableData = tableData.filter(
        (item) =>
          item.nome.toLowerCase().indexOf(filterName.toLowerCase()) !== -1
      );
    }
    return tableData;
  }

  async function handleCriarTag() {
    try {
      setLoading(true)
      const data = {
        nome: nome,
        cor_hex: corHex,
        usuario_id: user.id,
        cliente_id: user.clienteId
      }
      await v2_actionCriarTag(data);
      await buscarListaTags();
      setLoading(false)
      setOpenDialogNovoSetor(false);
      setNome('');
      setCorHex('gray'); // Nome da cor padrão
      setTagId('');
    } catch (error) {
      setLoading(false)
    }
  }

  async function handleDeletarTag() {
    try {
      await v2_actionDeletarTag(tagId);
      await buscarListaTags();
      setNome('');
      setCorHex('gray'); // Nome da cor padrão
      setTagId('');
      setOpenModalConfirmacao(false);

    } catch (error) {

    }

  }

  const handleEditarTag = async () => {
    try {
      await v2_actionEditarTag(tagId, { nome: nome, cor_hex: corHex });
      await buscarListaTags();
      setAction('');
      setNome('');
      setCorHex('gray'); // Nome da cor padrão
      setTagId('');
      setOpenDialogNovoSetor(false);
    } catch (error) {
      console.log('error', error)
    }

  };

  const dataFiltered = applyFilter(listaTags, pesquisa);

  return (
    <div className={TAGS_COMPONENT_DESIGN.page.container}>
      {/* Header */}
      <div className={TAGS_COMPONENT_DESIGN.page.header.container}>
        <div>
          <h1 className={TAGS_COMPONENT_DESIGN.page.header.title}>Etiquetas</h1>
          <p className={TAGS_COMPONENT_DESIGN.page.header.subtitle}>
            Crie etiquetas para organizar suas conversas e atendimentos.
          </p>
        </div>
        <button
          onClick={() => {
            setOpenDialogNovoSetor(true);
            setAction('Criar')
          }}
          className={TAGS_COMPONENT_DESIGN.page.actionButton}
        >
          <Plus size={18} />
          <span>Criar Etiqueta</span>
        </button>
      </div>

      <ModalConfimacao
        open={openModalConfirmacao}
        onClose={() => {
          setOpenModalConfirmacao(false);
        }}
        onConfirm={handleDeletarTag}
        loadingFinalizar={loading}
        mensagem={'Deseja mesmo excluir essa etiqueta?'}
      />

      <ModalTags
        open={openDialogNovoSetor}
        action={action}
        nome={nome}
        changeNome={(e) => {
          setNome(e.target.value)
        }}
        corHex={corHex}
        changeCorHex={(value) => {
          setCorHex(value)
        }}
        onSubmit={action === "Criar" ? handleCriarTag : handleEditarTag}
        onClose={() => {
          setOpenDialogNovoSetor(false);
          setNome('');
          setCorHex('gray'); // Nome da cor padrão
          setTagId('');
        }}
      />

      {/* List */}
      <div className="flex flex-col gap-4">
        {listaTags.length === 0 ? (
          <div className={TAGS_COMPONENT_DESIGN.emptyState.container}>
            <div className={TAGS_COMPONENT_DESIGN.emptyState.iconBox}>
              <Tag size={32} />
            </div>
            <h3 className={TAGS_COMPONENT_DESIGN.emptyState.title}>Nenhuma etiqueta criada</h3>
            <p className={TAGS_COMPONENT_DESIGN.emptyState.description}>
              Crie etiquetas para classificar e organizar seus contatos.
            </p>
            <button
              onClick={() => {
                setOpenDialogNovoSetor(true);
                setAction('Criar')
              }}
              className={TAGS_COMPONENT_DESIGN.emptyState.button}
            >
              Criar minha primeira etiqueta
            </button>
          </div>
        ) : (
          <GenericTable headLabels={TABLE_HEAD}>
            {dataFiltered.map((row) => (
              <div
                key={row._id}
                className={GENERIC_TABLE_DESIGN.row.container}
              >
                {/* Nome & Data */}
                <div className={GENERIC_TABLE_DESIGN.common.colMain}>
                  <div className="flex items-center gap-3">
                    <div className={GENERIC_TABLE_DESIGN.common.iconBox}>
                      <Hash size={20} />
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-gray-900">{row.nome}</h3>
                      <div className="flex items-center gap-2 mt-0.5">
                        <span className="text-[10px] text-gray-400">Criada em {fDate(row.date)}</span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Cor */}
                <div className="w-48 text-center flex justify-center">
                  <div className="flex items-center gap-2 px-3 py-1 bg-gray-50 rounded-lg border border-gray-100">
                    <span className={`w-5 h-3 rounded-full hover:shadow-sm ${getColorClass(row.cor_hex)}`} />
                  </div>
                </div>

                {/* Actions */}
                <div className="w-24 flex justify-end gap-1">
                  <Tooltip title="Editar">
                    <button
                      onClick={() => {
                        setOpenDialogNovoSetor(true)
                        setAction('Editar')
                        setTagId(row._id);
                        setNome(row.nome);
                        // Converte hex antigo para nome da cor se necessário
                        setCorHex(convertHexToColorName(row.cor_hex) || 'gray');
                      }}
                      className="p-2 rounded-lg text-gray-400 hover:bg-gray-50 hover:text-gray-600 transition-all"
                    >
                      <Pencil size={18} />
                    </button>
                  </Tooltip>
                  <Tooltip title="Excluir">
                    <button
                      onClick={() => {
                        setTagId(row._id);
                        setOpenModalConfirmacao(true);
                      }}
                      className={GENERIC_TABLE_DESIGN.common.deleteButton}
                    >
                      <Trash2 size={18} />
                    </button>
                  </Tooltip>
                </div>
              </div>
            ))}
          </GenericTable>
        )}
      </div>
    </div>
  );
}
